function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#USDT_svg__clip0_1_126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 28.2c7.594 0 13.75-5.91 13.75-13.2 0-7.29-6.156-13.2-13.75-13.2S1.25 7.71 1.25 15c0 7.29 6.156 13.2 13.75 13.2z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 29.4C6.716 29.4 0 22.953 0 15S6.716.6 15 .6C23.284.6 30 7.047 30 15s-6.716 14.4-15 14.4zm1.802-16.386v-2.13h5.076V7.637H8.058v3.247h5.075v2.129c-4.125.182-7.227.966-7.227 1.906s3.103 1.724 7.228 1.906v6.824h3.668v-6.826c4.119-.181 7.213-.966 7.213-1.904s-3.095-1.723-7.213-1.905zm0 3.23v-.001c-.103.007-.634.037-1.82.037-.948 0-1.614-.026-1.848-.037v.003c-3.645-.154-6.366-.764-6.366-1.493 0-.727 2.72-1.337 6.365-1.494v2.38c.238.016.92.055 1.864.055 1.132 0 1.699-.045 1.805-.054V13.26c3.637.156 6.351.765 6.351 1.492 0 .73-2.714 1.337-6.351 1.492z",
  fill: "#26A17B"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "USDT_svg__clip0_1_126"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "6e21d2b9985d175dd8e15d02de61ed45.svg";
export { SvgUsdt as ReactComponent };